// "Koszyk" porównywanych wykładowców trzymany w localStorage, żeby przetrwał
// przechodzenie między stronami (tak jak koszyk w sklepie).
const STORAGE_KEY = "mumin_compare_ids";

export function getCompareIds(): number[] {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((value): value is number => typeof value === "number");
    } catch {
        return [];
    }
}

function setCompareIds(ids: number[]): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    window.dispatchEvent(new CustomEvent("compare-changed"));
}

export function isInCompare(id: number): boolean {
    return getCompareIds().includes(id);
}

export function addToCompare(id: number): void {
    const ids = getCompareIds();
    if (!ids.includes(id)) {
        setCompareIds([...ids, id]);
    }
}

export function removeFromCompare(id: number): void {
    setCompareIds(getCompareIds().filter((existingId) => existingId !== id));
}

export function clearCompare(): void {
    setCompareIds([]);
}

// Nadpisuje koszyk CAŁYM podanym zestawem (nie dokłada do istniejącego) - używane przez
// "Porównaj wszystkich" przy liście prowadzących danego przedmiotu (patrz subjectTeacherLinks.ts):
// kliknięcie ma pokazać DOKŁADNIE prowadzących tego przedmiotu, nie zmieszanych z tym, co ktoś
// mógł wcześniej dodać do koszyka z zupełnie innej listy.
export function replaceCompare(ids: number[]): void {
    setCompareIds(ids);
}

export function toggleCompare(id: number): boolean {
    if (isInCompare(id)) {
        removeFromCompare(id);
        return false;
    }
    addToCompare(id);
    return true;
}
